import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../../services';
import { useAuth } from '../../context/AuthContext';
import '../Login.css';

const GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI || 'https://marketingpro.app.br/auth/google/callback';

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303C33.655,32.657,29.221,36,24,36c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
      <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
      <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.143,35.091,26.715,36,24,36c-5.2,0-9.623-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
      <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.084,5.571c0.001-0.001,6.19,5.238,6.19,5.238C36.971,39.206,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
    </svg>
  );
}

function GoogleAuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [status, setStatus] = useState('Processando autenticação com Google...');
  const [error, setError] = useState('');
  const [googleLoading, setGoogleLoading] = useState(false);

  const handleRetryGoogle = async () => {
    setError('');
    setGoogleLoading(true);

    try {
      const redirectUri = GOOGLE_REDIRECT_URI;
      const data = await authService.googleAuth(redirectUri);

      if (!data?.success || !data?.auth_url) {
        setError(data?.message || 'Falha ao reiniciar autenticação com Google.');
        return;
      }

      window.location.assign(data.auth_url);
    } catch {
      setError('Erro de conexão durante autenticação Google.');
    } finally {
      setGoogleLoading(false);
    }
  };

  useEffect(() => {
    const processGoogleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code') || '';
      const state = params.get('state') || '';
      const oauthError = params.get('error') || '';

      if (oauthError) {
        setError('Autorização Google cancelada ou negada.');
        setStatus('Não foi possível concluir o login.');
        return;
      }

      if (!code || !state) {
        setError('Callback inválido: código de autorização ausente.');
        setStatus('Não foi possível concluir o login.');
        return;
      }

      try {
        const redirectUri = GOOGLE_REDIRECT_URI;
        const data = await authService.googleCallback({ code, state, redirect_uri: redirectUri });

        if (!data?.success) {
          setError(data?.message || 'Falha ao autenticar com Google.');
          setStatus('Não foi possível concluir o login.');
          return;
        }

        login(data);
        setStatus('Autenticação concluída. Redirecionando...');
        navigate('/dashboard', { replace: true });
      } catch (requestError) {
        setError('Erro de conexão durante autenticação Google.');
        setStatus('Não foi possível concluir o login.');
      }
    };

    processGoogleCallback();
  }, [login, navigate]);

  return (
    <div className="login-container">
      <div className="login-shell">
        <aside className="login-hero">
          <div className="login-hero-overlay" />
          <div className="login-hero-content">
            <span className="login-hero-tag">Marketing PRO</span>
            <h1>Conectando com Google</h1>
            <p>{status}</p>
          </div>
        </aside>

        <section className="login-panel">
          {error && <div className="error-message">{error}</div>}

          {error && (
            <button className="btn btn-full btn-google" type="button" onClick={handleRetryGoogle} disabled={googleLoading}>
              <span className="inner">
                <GoogleIcon />
                {googleLoading ? 'Conectando com Google...' : 'Tentar novamente com Google'}
              </span>
            </button>
          )}

          <div className="login-footer">
            <div className="signup-link">
              Voltar para <Link to="/login">login</Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default GoogleAuthCallback;
